import { TlfContextProps } from "./interface";

/**
 * Updates the active patch composition captured by unified editable-data history.
 *
 * @param state - Current TLF context state
 * @param appliedPatchNames - Patch names composing the current TLF
 * @param activePatchName - Patch that should receive subsequent edits
 * @returns State with the current selection ready for unified history recording
 */
export const updateVariantPatchSelection = (
  state: TlfContextProps,
  appliedPatchNames: string[],
  activePatchName: string | null,
): TlfContextProps => {
  const appliedVariantPatches = [...appliedPatchNames];
  const nextActivePatchName = appliedPatchNames.length === 0 ? null : activePatchName;
  return {
    ...state,
    appliedVariantPatches,
    activeVariantPatchName: nextActivePatchName,
  };
};
